module.exports = __webpack_public_path__ + "static/media/coachProfile.fd5d9b18.svg";